import { useQuery } from '@tanstack/react-query'
import { preloadImage } from 'src/helpers/image'
import { QUERY_DATA } from 'src/service'

export const useImage = (image: string, opts?: { enabled?: boolean }) => {
  const { enabled = true } = opts || {}

  return useQuery({
    queryKey: [QUERY_DATA.IMAGE, image],
    queryFn: () => preloadImage(image),
    initialData: {
      width: 0,
      height: 0,
    },
    enabled,
  })
}
